<div
  class="container"
  data-testid="wrapper"
  [attr.test-style]="gridTemplateColumns"
  [ngStyle.gt-md]="{ gridTemplateColumns: gridTemplateColumns }"
>
  <div class="ga-left" data-testid="left" [ngClass]="leftEl?.parentClass">
    <ng-content select="[am-layout-left]"></ng-content>
  </div>
  <div class="ga-main" data-testid="main" [ngClass]="mainEl?.parentClass">
    <ng-content select="[am-layout-main]"></ng-content>
  </div>
  <div class="ga-right" data-testid="right" [ngClass]="rightEl?.parentClass">
    <ng-content select="[am-layout-right]"></ng-content>
  </div>
</div>
